import React from 'react';
import { 
  FaCloud, FaShieldAlt, FaSyncAlt, FaMobileAlt, 
  FaHeadset, FaChartBar, FaLock, FaRocket
} from 'react-icons/fa';
import './Benefits.css';

const Benefits = () => {
  const benefits = [
    {
      icon: <FaCloud />,
      title: '100% en la Nube',
      description: 'Accede desde cualquier lugar sin instalaciones. Tus datos siempre disponibles y seguros.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Máxima Seguridad',
      description: 'Cumplimiento RGPD, encriptación de datos y backup automático para proteger tu información.'
    },
    {
      icon: <FaSyncAlt />,
      title: 'Actualizaciones Automáticas',
      description: 'Nuevas funcionalidades y mejoras sin costes adicionales ni interrupciones.'
    },
    {
      icon: <FaMobileAlt />,
      title: 'Multi-plataforma',
      description: 'Disponible en web, iOS y Android. Gestiona tu club desde cualquier dispositivo.'
    },
    {
      icon: <FaHeadset />,
      title: 'Soporte Técnico',
      description: 'Asistencia personalizada para resolver cualquier duda o incidencia rápidamente.'
    },
    {
      icon: <FaChartBar />,
      title: 'Informes Profesionales',
      description: 'Genera informes detallados en PDF con estadísticas y gráficos profesionales.'
    },
    {
      icon: <FaLock />,
      title: 'Control de Accesos',
      description: 'Sistema de roles y permisos para mantener la información sensible protegida.'
    },
    {
      icon: <FaRocket />,
      title: 'Rápido y Eficiente',
      description: 'Interfaz intuitiva y rápida que reduce el tiempo de gestión diaria.'
    }
  ];

  return (
    <section id="beneficios" className="benefits dark bg-gradient">
      <div className="container">
        <h2 className="section-title">
          ¿Por qué elegir <span className="highlight">Gestión Club</span>?
        </h2>
        <p className="section-subtitle">
          Desarrollado desde las necesidades reales de asociaciones cannábicas en Barcelona.
          Software probado y confiable.
        </p>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="benefit-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="benefit-icon-wrapper">
                <div className="benefit-icon">{benefit.icon}</div>
              </div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="cta-section">
          <div className="cta-content">
            <h3 className="cta-title">¿Listo para profesionalizar tu club?</h3>
            <p className="cta-text">
              Solicita una demo gratuita y descubre cómo Gestión Club puede
              transformar la gestión de tu asociación cannábica.
            </p>
            <button 
              className="btn btn-primary btn-large"
              onClick={() => {
                const element = document.getElementById('contacto');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              <FaRocket /> Solicitar Demo Gratuita
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;

